import { defineStore } from 'pinia'

export default defineStore({
  id: 'settings',
  persist: true,
  state: () => {
    return {
      globalSettings: {}
    }
  },
  actions: {
    setGlobalSettings: function (payload: any) {
      this.globalSettings = payload
    }
  },
  getters: {
    getGlobalSettings: (state: any) => state.globalSettings
  }
})
